
import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import { Field, Form, Formik } from "formik";
import { useDispatch } from 'react-redux';
import { mackBookApi } from "../../../services/iPhoneApiService";
import { addToCart } from "../../../store/actions/cart";
import { isEmpty } from "../../../validation/index";
import LoaderSpinner from "../../Loader/loaderSpinner";
import EditIcon from '@material-ui/icons/Edit'

import { v4 as uuidv4 } from 'uuid';


const deviceList = 
[
    {
        devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Macbook/Macbook/macbook-12.jpg',
        deviceName: "MacBook",
        label: "MacBook",
        size: [
            {
                size: "12\"",
                sizeLabel: "MacBook 12\" (2015-2017)",
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Macbook/Macbook/macbook-12.jpg",
                years: [
                    {
                        year: "MacBook 12\" (2017)",
                        Condition: [{ name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }],
                        processor: [
                            {   GCard:"null",
                                ram: ["8GB RAM", "16GB RAM"],
                                gb: ["128GB SSD","256GB SSD", "512GB SSD"]
                            },
                           
                        ],
                        
                    },
                    {
                        year: "MacBook 12\" (2016)",
                        Condition: [{ name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear., Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }],
                        processor: [
                            {   
                                GCard:"null",
                                ram: ["8GB RAM"],
                                gb: ["256GB SSD", "512GB SSD"]
                            },
                           
                        ],
                        
                    },
                    
                ]
            }
        ],
    },

    {
        devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Macbook/Macbook+Air/1001626288-macbook-air.png',
        deviceName: "MacBook Air",
        label: "MacBook Air",
        size: [
            {
                size: "13\"",
                sizeLabel: "MacBook Air 13\" (2015 - 2020)",
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Macbook/Macbook+Air/1001626288-macbook-air.png",
                years: [
                    {
                        year: "MacBook Air 13\" (2015)",
                        Condition: [{ name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }],
                        processor: [
                            { 
                                GCard:"null",
                                ram: ["8GB RAM"],
                                gb: ["128GB SSD"]
                            } 
                           
                        ],
                        
                    },
                    {
                        year: "MacBook Air 13\" (2016)",
                        Condition: [{ name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }],
                        processor: [
                            { 
                                GCard:"null",
                                ram: ["8GB RAM"],
                                gb: ["128GB SSD","256GB SSD"]
                            } 
                           
                        ],
                        
                    },
                    {
                        year: "MacBook Air 13\" (2017)",
                        Condition: [{ name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }],
                        processor: [
                            { 
                                GCard:"null",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["128GB SSD","256GB SSD","512GB SSD"]
                            } 
                           
                        ],
                        
                    },
                    {
                        year: "MacBook Air 13\" (2018)",
                        Condition: [{ name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }],
                        processor: [
                            { 
                                GCard:"null",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["128GB SSD","256GB SSD","512GB SSD","1.5TB SSD"]
                            } 
                           
                        ],
                        
                    },
                    {
                        year: "MacBook Air 13\" (2019)",
                        Condition: [{ name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }],
                        processor: [
                            { 
                                GCard:"null",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["128GB SSD","256GB SSD","512GB SSD", "1TB SSD"]
                            } 
                           
                        ],
                        
                    },
                    {
                        year: "MacBook Air 13\" (2020)",
                        Condition: [{ name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }],
                        processor: [
                            { 
                                GCard:"M1 Chip (8 Core GPU)",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            },
                            { 
                                GCard:"M1 Chip (7 Core GPU)",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            } ,
                            { 
                                GCard:"1.2 GHz Intel Core i7",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            }  ,
                            { 
                                GCard:"1.1 GHz Intel Core i5",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            }  ,
                            { 
                                GCard:"1.1 GHz Intel Core i3",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            } 
                            
                           
                        ],
                        
                    },
                ]
            },{
                size: "13\"",
                sizeLabel: "MacBook Air 13\" (2022-Present)",
                imagePath:"https://sellmydevice.s3.ca-central-1.amazonaws.com/Macbook/Macbook+Pro/MacbookPro2012-2015/macbook-air-13-2024.jpg.webp",
                years: [
                    
                    {
                        year: "MacBook Air 13\" (2022)",
                        Condition: [ {name: 'Brand New', label: 'Brand new device. Comes with the box and all accessories sealed/untouched.'},
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }
                            ],
                        processor: [
                            { 
                                GCard:"M2 8-Core, 8-Core GPU",
                                ram: ["8GB RAM","16GB RAM","24GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            } ,
                            { 
                                GCard:"M2 8-Core, 10-Core GPU",
                                ram: ["8GB RAM","16GB RAM","24GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            } ,

                        ],
                        
                    },
                    {
                        year: "MacBook Air 13\" (2024)",
                        Condition: [
                            {name: 'Brand New', label: 'Brand new device. Comes with the box and all accessories sealed/untouched.'},
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }
                            ],
                        processor: [
                            { 
                                GCard:"M4 10-Core, 10-Core GPU",
                                ram: ["16GB RAM","24GB RAM","32GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            } 

                        ],
                        
                    },
                    
                ]
            },
            {
                size: "15\"",
                sizeLabel: "MacBook Air 15\" (2023-Present)",
                imagePath:"https://sellmydevice.s3.ca-central-1.amazonaws.com/Macbook/Macbook+Pro/MacbookPro2012-2015/macbook-air-15-2024.jpg.webp",
                years: [
                    
                    {
                        year: "MacBook Air 15\" (2023)",
                        Condition: [
                            {name: 'Brand New', label: 'Brand new device. Comes with the box and all accessories sealed/untouched.'},
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }
                            ],
                        processor: [
                            { 
                                GCard:"null",
                                ram: ["8GB RAM","16GB RAM","24GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            } 

                        ],
                        
                    },
                    {
                        year: "MacBook Air 15\" (2024)",
                        Condition: [
                            {name: 'Brand New', label: 'Brand new device. Comes with the box and all accessories sealed/untouched.'},
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }
                            ],
                        processor: [
                            { 
                                GCard:"null",
                                ram: ["16GB RAM","24GB RAM","32GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            } 

                        ],
                        
                    },
                ]
            },
            
            {
                size: "13\"",
                sizeLabel: "MacBook Air 13\" (2013 - 2017)",
                imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/Macbook/Macbook+Air/1001626288-macbook-air.png",

                years: [
                    {
                        year: "MacBook Air 13\" (2017)",
                        Condition: [{ name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }],
                        processor: [
                            {   GCard:"null",
                                ram: ["8GB RAM", "16GB RAM"],
                                gb: ["128GB SSD","256GB SSD", "512GB SSD"]
                            },
                           
                        ],
                        
                    },
                    {
                        year: "MacBook Air 13\" (2016)",
                        Condition: [{ name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }],
                        processor: [
                            {   GCard:"null",
                                ram: ["8GB RAM"],
                                gb: ["128GB SSD","256GB SSD"]
                            },
                           
                        ],
                        
                    },
                    {
                        year: "MacBook Air 13\" (2015)",
                        Condition: [{ name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }],
                        processor: [
                            {   GCard:"null",
                                ram: ["8GB RAM"],
                                gb: ["128GB SSD","256GB SSD"]
                            },
                           
                        ],
                        
                    },
                ]
            }
        ],
    },

    {
        devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Macbook/Macbook+Pro/macbook-pro.png',
        deviceName: "MacBook Pro",
        label: "MacBook Pro",
        size: [
            {
                size: "13\"",
                sizeLabel: "MacBook Pro 13\" - Retina (2015 - 2020)",
                imagePath:"https://sellmydevice.s3.ca-central-1.amazonaws.com/Macbook/Macbook+Pro/MacbookPro2012-2015/macbook-pro-retina-13.jpg.webp",
                years: [
                    
                    {
                        year: "MacBook Pro 13\" (2015)",
                        Condition: [
                           
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }
                            ],
                        processor: [
                            { 
                                GCard:"null",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD"]
                            } 

                        ],
                        
                    },
                    {
                        year: "MacBook Pro 13\" (2016)",
                        Condition: [
                           
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }
                            ],
                        processor: [
                            { 
                                GCard:"null",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD"]
                            } 

                        ],
                        
                    },
                    {
                        year: "MacBook Pro 13\" (2017)",
                        Condition: [
                           
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }
                            ],
                        processor: [
                            { 
                                GCard:"null",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["128GB SSD","256GB SSD","512GB SSD","1TB SSD"]
                            } 

                        ],
                        
                    },
                    {
                        year: "MacBook Pro 13\" (2018)",
                        Condition: [
                           
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }
                            ],
                        processor: [
                            { 
                                GCard:"2.7 GHz Intel Core i7",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD"]
                            } ,
                            { 
                                GCard:"2.3 GHz Intel Core i5",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD"]
                            } 

                        ],
                        
                    },
                    {
                        year: "MacBook Pro 13\" (2019)",
                        Condition: [
                           
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }
                            ],
                        processor: [
                            { 
                                GCard:"2.8 GHz Intel Core i7",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            } ,
                            { 
                                GCard:"2.4 GHz Intel Core i5",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["128GB SSD","256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            },
                            { 
                                GCard:"1.7 GHz Intel Core i7",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["128GB SSD","256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            } ,
                            { 
                                GCard:"1.4 GHz Intel Core i5",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["128GB SSD","256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            } 

                        ],
                        
                    },
                    {
                        year: "MacBook Pro 13\" (2020)",
                        Condition: [
                           
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }
                            ],
                        processor: [
                            { 
                                GCard:"M1 Chip",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD"]
                            } ,
                            { 
                                GCard:"2.3 GHz Intel Core i7",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["512GB SSD","1TB SSD","2TB SSD","4TB SSD"]
                            } ,{ 
                                GCard:"2.0 GHz Intel Core i5",
                                ram: ["16GB RAM","32GB RAM"],
                                gb: [,"512GB SSD","1TB SSD","2TB SSD"]
                            } ,
                            { 
                                GCard:"1.7 GHz Intel Core i7",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            } ,
                            { 
                                GCard:"1.4 GHz Intel Core i5",
                                ram: ["8GB RAM","16GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            } 


                        ],
                        
                    },
                ]
            },
            {
                size: "15\"",
                sizeLabel:"MacBook Pro 15\" - Retina (2015 - 2020)",
                imagePath:"https://sellmydevice.s3.ca-central-1.amazonaws.com/Macbook/Macbook+Pro/MacbookPro2012-2015/macbook-pro-retina-15.jpg.webp",
                years: [
                    
                    {
                        year: "MacBook Pro 15\" (2015)",
                        Condition: [
                           
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }
                            ],
                        processor: [
                            { 
                                GCard:"null",
                                ram: ["16GB RAM", "32GB RAM"],
                                gb: ["128GB SSD","256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            } 

                        ],
                        
                    },
                    {
                        year: "MacBook Pro 15\" (2016)",
                        Condition: [
                           
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }
                            ],
                        processor: [
                            { 
                                GCard:"null",
                                ram: ["16GB RAM", "32GB RAM"],
                                gb: ["128GB SSD","256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            } 

                        ],
                        
                    },
                    {
                        year: "MacBook Pro 15\" (2017)",
                        Condition: [
                           
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }
                            ],
                        processor: [
                            { 
                                GCard:"3.1 GHz Intel Core i7",
                                ram: ["16GB RAM",],
                                gb: ["256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            } ,
                            { 
                                GCard:"2.9 GHz Intel Core i7",
                                ram: ["16GB RAM",],
                                gb: ["512GB SSD","1TB SSD","2TB SSD"]
                            } ,
                            { 
                                GCard:"2.8 GHz Intel Core i7",
                                ram: ["8GB RAM","16GB RAM",],
                                gb: ["256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            } 

                        ],
                        
                    },
                    {
                        year: "MacBook Pro 15\" (2018)",
                        Condition: [
                           
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }
                            ],
                        processor: [
                            { 
                                GCard:"2.9 GHz Intel Core i9",
                                ram: ["16GB RAM","32GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD","2TB SSD"]
                            } ,
                            { 
                                GCard:"2.6 GHz Intel Core i7",
                                ram: ["16GB RAM","32GB RAM"],
                                gb: ["512GB SSD","1TB SSD","2TB SSD","4TB SSD"]
                            },
                             { 
                                GCard:"2.2 GHz Intel Core i7",
                                ram: ["16GB RAM","32GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD","2TB SSD","4TB SSD"]
                            } 

                        ],
                        
                    },
                    {
                        year: "MacBook Pro 15\" (2019)",
                        Condition: [
                           
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }
                            ],
                        processor: [
                            { 
                                GCard:"2.4 GHz 8-core Intel Core i9",
                                ram: ["16GB RAM","32GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD","2TB SSD","4TB SSD"]
                            } ,
                            { 
                                GCard:"2.3 GHz 8-core Intel Core i9",
                                ram: ["16GB RAM","32GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD","2TB SSD","4TB SSD"]
                            },
                             { 
                                GCard:"2.6 GHz 6-core Intel Core i7",
                                ram: ["16GB RAM","32GB RAM"],
                                gb: ["256GB SSD","512GB SSD","1TB SSD","2TB SSD","4TB SSD"]
                            } 

                        ],
                        
                    },
                   
                ]
            },
           
            {
                size: "16\"",
                sizeLabel: "MacBook Pro 16\"- Touch Bar (2016 - 2020)",
                imagePath:"https://sellmydevice.s3.ca-central-1.amazonaws.com/Macbook/Macbook+Pro/MacbookPro2012-2015/macbook-pro-16-touch-bar.jpg.webp",
                years: [
                    {
                        year: "MacBook Pro 16\" (2019)",
                        Condition: [ { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }],
                        processor: [
                            { 
                                GCard:"2.4 GHz 8-core Intel Core i9",
                                ram: ["16GB RAM","32GB RAM","64GB RAM"],
                                gb: ["512GB SSD","1TB SSD","2TB SSD","4TB SSD","8TB SSD"]
                            } ,
                            { 
                                GCard:"2.3 GHz 8-core Intel Core i9",
                                ram: ["16GB RAM","32GB RAM","64GB RAM"],
                                gb: ["1TB SSD","2TB SSD","4TB SSD","8TB SSD"]
                            },
                             { 
                                GCard:"2.6 GHz 6-core Intel Core i7",
                                ram: ["16GB RAM","32GB RAM","64GB RAM"],
                                gb: ["512GB SSD","1TB SSD","2TB SSD","4TB SSD","8TB SSD"]
                            } 
                        ],
                       
                    }
                ]
            },
            {
                size: "14\"",
                sizeLabel: "MacBook Pro 14\"(2021 - Present)",
                imagePath:"https://sellmydevice.s3.ca-central-1.amazonaws.com/Macbook/Macbook+Pro/MacbookPro2012-2015/macbook-pro-16-m3.jpg.webp",
                years: [
                    {
                        year: "MacBook Pro 14\" (2024)",
                        Condition: [
                            { name: 'Brand New', label: 'Brand new device. Comes with the box and all accessories sealed/untouched.' },
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                             { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                            { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                            { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                             { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }],
                        processor: [
                            {
                                
                                GCard: "M4 10-Core, 10-Core GPU",
                                ram: ["16GB RAM","24GB RAM", "32GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD"]
                            },
                            {
                              
                                GCard: "M4 Pro 12-Core, 16-Core GPU",
                                ram: ["24GB RAM", "48GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD"]
                            },
                            {
                              
                                GCard: "M4 Pro 14-Core, 20-Core GPU",
                                ram: ["24GB RAM", "48GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD"]
                            },
                            {
                              
                                GCard:"M4 Max 14-Core, 32-Core GPU",
                                ram: ["36GB RAM"],
                                gb:["1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            },
                            {
                              
                                GCard:"M4 Max 16-Core, 40-Core GPU",
                                ram: ["48GB RAM","64GB RAM","128GB RAM"],
                                gb:["1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            },
                        ],
                        
                    },
                    {
                        year: "MacBook Pro 14\" (Nov 2023)",
                        Condition: [{ name: 'Brand New', label: 'Brand new device. Comes with the box and all accessories sealed/untouched.' },
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                           { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                           { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                            { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }
                        ],
                        processor: [
                            {
                               
                                GCard: "M3 8-Core, 10-Core GPU",
                                ram: [ "8GB RAM","16GB RAM","24GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD"],
                            },
                            {
                              
                                GCard: "M3 Pro 11-Core, 14-Core GPU",
                                ram: [ "18GB RAM","36GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD"]
                            },
                            {
                              
                                GCard:"M3 Pro 12-Core, 18-Core GPU",
                                ram: [ "18GB RAM","36GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD"]
                            },
                            {
                                
                                GCard:"M3 Max 14-Core, 30-Core GPU", 
                                ram: [ "36GB RAM","96GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            },
                            {
                              
                                GCard:"M3 Max 16-Core, 40-Core GPU",
                                ram: [ "48GB RAM","64GB RAM","128GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            },
                        ],
                       
                    },
                    {
                        year: "MacBook Pro 14\" (2023)",
                        Condition: [{ name: 'Brand New', label: 'Brand new device. Comes with the box and all accessories sealed/untouched.' },
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                           { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                           { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                            { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }
                        ],
                        processor: [
                           
                            {
                               
                                GCard:  "M2 Pro 10-Core, 16-Core GPU",
                                ram: ["16GB RAM", "32GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            },
                            {
                               
                                GCard:  "M2 Pro 12-Core, 19-Core GPU",
                                ram: ["16GB RAM", "32GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            },
                            {
                              
                                GCard:"M2 Max 12-Core, 30-Core GPU", 
                                ram: [ "32GB RAM","64GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            },
                            {
                              
                                GCard:"M2 Max 12-Core, 38-Core GPU",
                                ram: [ "32GB RAM","64GB RAM","96GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            }
                        ],
                        
                    },
                    
               
                    {
                        year: "MacBook Pro 14\" (2021)",
                        Condition: [
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                           { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                           { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                            { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }],
                        processor: [
                            {
                               
                                GCard: "M1 Pro 8-Core, 14-Core GPU",
                                ram: ["16GB RAM", "32GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            },
                            {
                               
                                GCard: "M1 Pro 10-Core, 14-Core GPU",
                                ram: ["16GB RAM", "32GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            },
                            {
                               
                                GCard: "M1 Pro 10-Core, 16-Core GPU",
                                ram: ["16GB RAM", "32GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            },
                            {
                                
                                GCard:  "M1 Max 10-Core, 24-Core GPU",
                                ram: [ "32GB RAM","64GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            },
                            {
                                
                                GCard:  "M1 Max 10-Core, 32-Core GPU",
                                ram: [ "32GB RAM","64GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            }
                        ],
                        
                    }
                ]
            },
            {
                size: "16\"",
                sizeLabel: "MacBook Pro 16\"(2021 - Present)",
                imagePath:"https://sellmydevice.s3.ca-central-1.amazonaws.com/Macbook/Macbook+Pro/MacbookPro2012-2015/macbook-pro-14-m3.jpg.webp",
                years: [
                    {
                        year: "MacBook Pro 16\" (2024)",
                        Condition: [{  name: 'Brand New', label: 'Brand new device. Comes with the box and all accessories sealed/untouched.' },
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                           { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                           { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                            { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }],
                        processor: [
                            
                            {
                              
                                GCard: "M4 Pro 14-Core, 20-Core GPU",
                                ram: ["24GB RAM", "48GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD"]
                            },
                            {
                              
                                GCard:"M4 Max 14-Core, 32-Core GPU",
                                ram: ["36GB RAM"],
                                gb:["1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            },
                            {
                              
                                GCard:"M4 Max 16-Core, 40-Core GPU",
                                ram: ["48GB RAM","64GB RAM","128GB RAM"],
                                gb:["1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            },
                           
                            
                               
                                ]
                    }
                            
                       ,
                    {
                        year: "MacBook Pro 16\" (Nov 2023)",
                        Condition: [{  name: 'Brand New', label: 'Brand new device. Comes with the box and all accessories sealed/untouched.' },
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                           { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                           { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                            { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }
                        ],
                        processor: [
                            
                            {
                              
                                GCard:"M3 Pro 12-Core, 18-Core GPU",
                                ram: [ "18GB RAM","36GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD"]
                            },
                            {
                                
                                GCard:"M3 Max 14-Core, 30-Core GPU", 
                                ram: [ "36GB RAM","96GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            },
                            {
                              
                                GCard:"M3 Max 16-Core, 40-Core GPU",
                                ram: [ "48GB RAM","64GB RAM","128GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            },
                           
                        ],
                        
                    },
                    {
                        year: "MacBook Pro 16\" (2023)",
                        Condition: [{  name: 'Brand New', label: 'Brand new device. Comes with the box and all accessories sealed/untouched.' },
                            { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                           { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                           { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                            { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }
                        ],
                        processor: [
                           
                    
                            {
                               
                                GCard:  "M2 Pro 12-Core, 19-Core GPU",
                                ram: ["16GB RAM", "32GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            },
                            {
                              
                                GCard:"M2 Max 12-Core, 30-Core GPU", 
                                ram: [ "32GB RAM","64GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            },
                            {
                              
                                GCard:"M2 Max 12-Core, 38-Core GPU",
                                ram: [ "32GB RAM","64GB RAM","96GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            }
                        ],
                        
                    },
                    {
                        year: "MacBook Pro 16\" (2021)",
                        Condition: [ { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                           { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                           { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                            { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }],
                        processor: [
                            {
                               
                                GCard: "M1 Pro 10-Core, 16-Core GPU",
                                ram: ["16GB RAM", "32GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            },
                            {
                                
                                GCard:  "M1 Max 10-Core, 24-Core GPU",
                                ram: [ "32GB RAM","64GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            },
                            {
                                
                                GCard:  "M1 Max 10-Core, 32-Core GPU",
                                ram: [ "32GB RAM","64GB RAM"],
                                gb:["512GB SSD", "1TB SSD", "2TB SSD","4TB SSD","8TB SSD"]
                            }
                        ],
                        
                    },
                    
                ]
            },
            {
                size: "13\"",
                sizeLabel:"MacBook Pro 13\"(2021 - Present)",
                imagePath:"https://sellmydevice.s3.ca-central-1.amazonaws.com/Macbook/Macbook+Pro/MacbookPro2012-2015/macbook-pro-13-2022.jpg.webp",
                years: [
                    {
                        year: "MacBook Pro 13\" (2022)",
                        Condition: [ { name: 'Like New', label: 'Looks brand new. Contains no dents, dings or scratches.' }, 
                            { name: 'Good', label: 'Shows light  signs of wear. Contains light scratches and/or dents.' }, 
                           { name: 'Fair', label: 'Shows moderate to excessive signs of wear. Contains moderate scratches, dings, or dents.' },
                           { name: 'Defective', label: 'May have funcational issues, like speaker doesn\'t work, few keys doesn\'work etc., need to repair to make it 100% functional' },
                            { name: 'Broken', label: 'Deep cracks or broken parts on either screen or body of the item, Doesn\'t power on, water damaged.' }
                        ],
                        processor: [
                           { GCard:"null",
                            ram: ["8GB RAM", "16GB RAM", "24GB RAM"],
                            gb: ["256GB SSD", "512GB SSD", "1TB SSD", "2TB SSD"]}
                        ],
                       
                    },
                    
                    
                ]
            }
        ],
    }
]
    

const MacBook = (props) => {
    const dispatch = useDispatch();
    const [selectedDevice, setSelectedDevice] = useState()
    const [selectedDeviceSize, setSelectedDeviceSize] = useState()
    const [selectedDeviceYear, setSelectedDeviceYear] = useState()
    const [selectedDeviceProcessor, setSelectedDeviceProcessor] = useState()
    const [offerShow, setOfferShow] = useState(false)
    const [offers, setOffers] = useState()
    const [imagePath, setImagePath] = useState()
    const [isLoader, setIsLoader] = useState(false)
    const uuid = uuidv4()
    const [isBrokenOrNo, setIsBrokenOrNo] = useState(false)
    const [isBrandNew, setIsBrandNew] = useState(false)
    const [isBrokenFiled, setIsBrokenFiled] = useState(false)
    const [isProcessor, setIsProcessor] = useState(false)
    const [isGCard, setIsGCard] = useState(false)
    let { model } = useParams();
    const [items, setItems] = useState([]);

    useEffect(() => {
        if (model) {
            deviceList.filter(x => {
                if(x.label === model) {
                    setSelectedDevice([x])
                    setImagePath(x.imagePath);
                }
            })
        }
    }, [model])

    const selectDevice = (obj) => {
        props.history.push(`/Macbook/${obj.deviceName}`)
        window.location.reload()
    }
    
    const section1Ref=useRef()
        const scrollToSection = (ref) => {
            ref.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    };
    
    const handelSubmits = (value) => {
        setIsLoader(true);
        const year = value.year
        const deviceImage=value.size.split('///')[1]
        const processor=value.processor?value.processor:"" 
        const batteryHealth=value.batteryHealth
        const ChargingAdapter=value.powercord
        setImagePath(deviceImage)
        const obj = {
            model: year,
            processor: processor,
    
            ram: value.ram,
            capacity: value.capacity,
            deviceImages: deviceImage,
            deviceId: uuid

        }
        let customAmount = 0;

        //console.log(obj);
        //console.log(isBrandNew);



        mackBookApi(obj).then(res => {
            if (!isEmpty(res.data && res.data.results)) {
                setOffers(res.data.results)
            }
            setIsLoader(false)
            if (!isEmpty(res.data && res.data.results)) {
                let offer = +res.data.results[0].offer
                if(value.condition==="Brand New"){
                    offer=+res.data.results[0].brand_new
                    //console.log(offer)
                }
                if(value.condition==="Like New"){
                    offer=+res.data.results[0].like_new
                   //console.log(offer)
                }
                if(value.condition==="Good"){
                    offer=+res.data.results[0].good
                    //console.log(offer)
                }
                if(value.condition==="Fair"){
                    offer=+res.data.results[0].fair
                    //console.log(offer)
                }
                if(value.condition==="Defective"){
                    offer=+res.data.results[0].defective
                    //console.log(offer)
                }
                if(value.condition==="Broken"){
                    offer=+res.data.results[0].broken
                    //console.log(offer)
                }
                if(batteryHealth==="Poor"){
                    offer=offer-150
                    //console.log(offer)
                }
                if(ChargingAdapter==="No"){
                    offer=offer-35
                    //console.log(offer)
                }
                if(offer<=510){
                    offer=Math.ceil(offer-(offer*0.1))
                }
                
                offer = offer + customAmount;
                setOffers([{ ...res.data.results[0], offer }])
                if (offer <= 0) {
                    setIsBrokenOrNo(true)
                }
                
            }
        }).catch(err => {
            //console.log(err);
            setIsLoader(false)
        })
    }

    const deviceByYear = (x) => {
        if(x.processor[0].GCard==="null") {
            setIsProcessor(false)
            //console.log(isProcessor)
        } else {
            setIsProcessor(true)
            //console.log(isProcessor)
        }
        setSelectedDeviceYear(x)
        //console.log(x)
    }

    const deviceProcessor = (x) => {
       
        setSelectedDeviceProcessor(x)
    }

    const addCart = (value) => {
       
        //console.log(imagePath)
        const data = {
            deviceType: "MacBook",
            deviceModel: value.model,
            deviceCapacity: value.storage,
            deviceCarrier: "",
            deviceCondition: value.condition,
            deviceYear: value.year,
            deviceProcessor: value.processor,
            deviceOffer: parseInt(value.offer),
            deviceRAM:value.ram,
            deviceGeneration: "",
            deviceSize: value.screen_size,
            deviceEdition: "",
            deviceBand: "",
            deviceEngraving: "",
            deviceImages: imagePath,
            deviceId: uuid,
        }
        dispatch(addToCart(data))
        props.history.push("/cart");
        window.scroll(0,0);
    }

    const selectIWatchCondition = (value) => {
        if (value === 'Broken') {
            setIsBrandNew(false)
        } else if (value === 'Brand new') {
            setIsBrandNew(true)
        } else if (value === 'Flaw-less') {
            setIsBrandNew(false)
        } else if (value === 'Good') {
            setIsBrandNew(false)
        } else if (value === 'Fair') {
            setIsBrandNew(false)
        } else {
            return null;
        }
    }

    return (
        <div className="p-2 vh-70">
            <div className={!isEmpty(selectedDevice) ? 'device-selected' : ''}>
                  { isEmpty(selectedDevice) && 
                                    <span className="text-center"style={{fontSize:20}}>Select your MacBook Model</span>}
                {
                    isEmpty(selectedDevice) &&
                    <>
                        <div className="grid-container">
                        
                            {
                               
                                !isEmpty(deviceList) && deviceList.map((item, index) => (
                                    <div className="grid-item" key={index} onClick={() => selectDevice(item)}>
                                        <div className="bg-white">
                                            <img className=" cursor-pointer w-40 h-auto" src={item.devicePhoto} onClick={() => (selectDevice(item),setImagePath(`${item.devicePhoto}`))} />
                                        </div>
                                        <div className="text-center ">
                                            <span style={{fontSize:20, fontFamily:''}} onClick={() => selectDevice(item)} >{item.deviceName} </span>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </>
                }
            </div>
            <Formik
                initialValues={{
                    year: "",
                    condition: "",
                    size: "",
                    capacity: "",
                    ram: "",
                    powercord: "",
                    batteryHealth: "",
                    functional: "",
                    processor: "",
                    GCard: "",
                    ChargingAdapter: "",
                    MagicMouse: "",
                    MagicTrackpad: "",
                    MagicKeyboard: ""
                }}
                onSubmit={handelSubmits}
            >
                {({ handleChange, values }) => (
                    <Form>
                        {
                            selectedDevice &&
                            <div>
                                {selectedDevice[0].deviceName &&
                                    <div className="" >
                                        <div className="d-flex align-items-center">
                                        <div className="border border-dark rounded mx-2 my-2 p-2 bg-white justify-content-center" > 
                                        <img  className="bg-white"height="50" src={selectedDevice[0].devicePhoto}>
                                             </img>
                                             <span style={{fontSize:13, fontFamily:''}}>{selectedDevice[0].deviceName}</span> 
                                             </div>
                                             <button className="border rounded-lg ml-2" onClick={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "year",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "condition",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "size",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "capacity",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "ram",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "powercord",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "batteryHealth",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "functional",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "processor",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "GCard",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "MagicKeyboard",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "MagicTrackpad",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "MagicMouse",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "ChargingAdapter",
                                                        value: '',
                                                    }
                                                })
                                                setSelectedDevice()
                                                setOffers()
                                                setIsBrandNew(false)
                                                setIsBrokenOrNo(false)
                                            }} > <span className="ml-3"> <EditIcon/> 
                                            </span> 
                                            <span style={{fontSize:15}} className="ml-1 cursor-pointer text-info " > Change model</span>
                                        </button>
                                        </div>
                                        <hr />
                                        {!values.size &&
                                            <div>
                                                <span style={{fontSize:20, fontWeight:500}}>Select Year and Screen Size</span>
                                            </div>
                                        }
                                    </div>
                                }
                                 {selectedDevice[0].deviceName && !values.size &&
                                  
                                    <div className="grid-container">
                                       
                                            {selectedDevice[0].size.map((x, i) => (
                                                <div className="grid-item" key={i}>
                                                 
                                                    <label key={i} onClick= {() =>setSelectedDeviceSize(x)}>
                                                        <Field className="d-none" type="radio" name="size" value={x.size +'///'+ x.imagePath } onClick={() => setSelectedDeviceSize(x)}  />
                                                        <img className="cursor-pointer w-50 h-auto" src={x.imagePath} onClick={() =>(setSelectedDeviceSize(x),window.scrollTo(0, 0))} />
                                                        <div>
                                                            <span   variant="warning"><h7>{x.sizeLabel}</h7></span>
                                                        </div>
                                                     </label>
                                  
                                                </div>
                                            ))}
                                        </div>
                                   
                                    
                                }
                                {
                                    selectedDevice[0].deviceName && values.size && <>
                                        <div className="d-flex align-items-center">
                                        <div className="border border-dark rounded mx-2 my-2 p-2 bg-white justify-content-center" > 
                                        <img  className="bg-white"height="50"src={selectedDeviceSize.imagePath}/>
                                        <div>
                                        <span style={{fontSize:13, fontFamily:''}}>{selectedDeviceSize.sizeLabel}</span>  
                                        </div>
                                       
                                            </div>
                                            <button className="border rounded-lg ml-2"
                                            onClick={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "year",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "condition",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "size",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "capacity",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "ram",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "powercord",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "batteryHealth",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "functional",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "processor",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "GCard",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "MagicKeyboard",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "MagicTrackpad",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "MagicMouse",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "ChargingAdapter",
                                                        value: '',
                                                    }
                                                })
                                                setOffers()
                                                setSelectedDeviceSize();
                                                setIsBrandNew(false)
                                            }} >  <span className="ml-3"> <EditIcon/>
                                            </span> 
                                            <span className="ml-1 cursor-pointer text-info "> Change size and/or year</span>
                                            </button>
                                        </div>
                                        <hr />
                                        {values.size && !values.year &&
                                            <>
                                                <span style={{fontSize:20}}>Select year of your macbook</span>
                                            </>
                                        }
                                    </>
                                }

                                {selectedDeviceSize && values.size && !values.year &&
                                    <div role="group" aria-labelledby="my-radio-group">
                                        <div className="grid-container">
                                            {selectedDeviceSize.years.map((x, i) => (
                                                <>
                                                    <label key={i} className="border border-dark  cursor-pointer rounded p-2">
                                                        <Field className="d-none" type="radio" name="year" onClick={() => deviceByYear(x)
                                                        } value={x.year} />
                                                        {x.year}
                                                    </label>
                                                </>
                                            ))}
                                        </div>
                                    </div>
                                }

                                {
                                    selectedDeviceSize && values.size && values.year && <>
                                        <div className="d-flex align-items-center">
                                        <div className="border border-dark rounded mx-2  p-2" >
                                            <span style={{fontSize:14}}> 
                                                {values.year}
                                            </span>
                                        </div>
                                            <button className="border rounded-lg ml-2"
                                            onClick={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "year",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "condition",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "capacity",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "ram",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "powercord",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "batteryHealth",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "functional",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "processor",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "GCard",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "MagicKeyboard",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "MagicTrackpad",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "MagicMouse",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "ChargingAdapter",
                                                        value: '',
                                                    }
                                                })
                                                setOffers()
                                                setSelectedDeviceYear()
                                                setIsBrokenOrNo(false)
                                            }} > <span className=""> <EditIcon/> </span>
                                            <span className="ml-1 cursor-pointer text-info">  Change year</span>
                                            </button>
                                        </div>
                                        <hr />
                                        {values.year && !values.condition &&
                                            <div className="ml-2">
                                                <span style={{fontSize:20, fontWeight:500}}>Select MacBook's cosmetic condition:</span>
                                            </div>
                                        }
                                    </>
                                }

                                 
                                {selectedDeviceYear && values.size && values.year && !values.condition &&
                                    <>
                                        {/*Modal trigger */} 
                                 <a type="link" data-toggle="modal" data-target="#exampleModalCenter">
                                 <span style={{fontSize:14}}className="text-danger cursor-pointer ml-2"><u>Learn more about how to determine the condition of the MacBook?</u></span></a>
                                                        {/*Modal */} 
                                                        <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                                            <div class="modal-dialog modal-dialog-centered" role="document">
                                                                <div class="modal-content">
                                                                    <div class="modal-header">
                                                                        <h5 class="modal-title" id="exampleModalLongTitle">Determine the cosmetic conditions of your MacBook</h5>
                                                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                                        <span aria-hidden="true">&times;</span>
                                                                        </button>
                                                                    </div>
                                                                    <div class="modal-body">
                                                                        <p>It is important to accurately rate the physical and functional condition of your item. These conditions are crucial to helping sell my device  meet your expectations.</p>
                                                                        <p><strong>Brand new (if all of the following is true):</strong>
                                                                            <ul>
                                                                                <li> MacBook is still in original packaging and sealed in the box which also includes all the accessories comes inside it..</li>
                                                                                <li> MacBook is untouched.</li>
                                                                                <li> MacBook's box never been opened.</li>
                                                                                <li> MacBook's warranty hasn't been activated yet.</li>
                                                                            </ul>
                                                                        </p>
                                                                        <p><strong>Like new (if all of the following is true):</strong>
                                                                            <ul>
                                                                                <li> MacBook is in immmaculate cosmetic condition comes with all the accessories.</li>
                                                                                <li> Your MacBook is in  working order with no cosmetic signs of wear and tear or any scratches and/or dents anywhere on the body of MacBook. or/and on the display</li>
                                                                                <li> MacBook battery health status must be Normal.</li>
                                                                                <li> MacBook must not have any sign of water damage or stains on outer body.</li>
                                                                            </ul>
                                                                        </p>
                                                                        <p><strong>Good (if all of the following is true):</strong>
                                                                            <ul>
                                                                                <li> Your MacBook is in great working order with few minor cosmetic signs of wear and light one or two scratches and/or dents.</li>
                                                                                <li>MacBook has few light marks of use, battery health status must be Normal.</li>
                                                                                <li> MacBook must not have any sign of water damage or stains on outer body.</li>
                                                                            </ul>
                                                                        </p>
                                                                        <p><strong>Fair(if all of the following is true):</strong>
                                                                
                                                                            <ul>
                                                                                <li> Your MacBook is in  working order with several cosmetic signs of wear.</li>
                                                                                <li> MacBook has moderate to heavy marks of use with deep scuffs and/or dents on outer body and/or on Display.</li>
                                                                                <li> Battery health status must be Normal</li>
                                                                                <li> MacBook must not have any sign of water damages.</li>
                                                                            </ul>
                                                            
                                                                        </p>
                                                                        <p><strong>Defecitve (if any of the following is true):</strong>
                                                                
                                                                            <ul>
                                                                                <li>  Your MacBook is in working order and may have functionality issues like camera don't work, speaker making fussy noise, touch id don't work and etc.</li>
                                                                                <li> Battery health status is service recommended or replace now, anything other than Normal.</li>
                                                                                <li> Need repairs to make it 100% functional.</li>
                                                                                <li> No sign of water damages</li>
                                                                                <li> May have stains on outer surface of MacBook or worn out color from the body of MacBook</li>
                                                    
                                                                            </ul>
                                                                        </p>
                                                                        <p><strong>Broken (if any of the following is true):</strong>
                                                                
                                                                            <ul>
                                                                                <li> Does not power on.</li>
                                                                                <li> Broken or cracked LCD screen or glass.</li>
                                                                                <li> Missing buttons (power button, Touch Id, any keys, volume).</li>
                                                                                <li> Broken or cracked hardware (charging ports, casing, etc.)
                                                                                Housing separation beyond the width of a nickel,
                                                                                have signs of water damages.</li>
                                                                            </ul>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>   
                                                        {isEmpty(offers) && selectedDeviceYear &&
                                                        <>
                                                         <div>
                                                         <div role="group" className="grid-container" aria-labelledby="my-radio-group">
                                                            <div className= {`${values.condition=== "Brand New"&&'grid-item1-bg'|| 'grid-item1'} `}>
                                                                <div className="d-flex justify-content-between">
                                                                            <label className="h7"><strong>Brand New</strong> </label>
                                                                                    <Field className="mt-1" type="radio" name="condition" value='Brand New'  onClick={()=>scrollToSection(section1Ref)}/>
                                                                </div>
                                                                    <hr></hr>
                                                                    <label className="">
                                                                    <span style={{fontSize:14}} className="extra-txt ng-binding" ng-show="answer.tooltip.length"> 
                                                                    <span style={{fontSize:15, fontWeight:500}}>All of the below is true </span>
                                                                            <ul>
                                                                                <li>Sealed in the original company packaging.</li>
                                                                                <li>Comes with all the accessories inside.</li>
                                                                                <li>Warranty hasn't been activated on it yet.</li>
                                                                
                        
                                                                            </ul>
                                                                            
                                                                        </span>
                                                                    </label>
                                                            </div>
                                                        <div className= {`${values.condition=== "Like New"&&'grid-item1-bg'|| 'grid-item1'} `}>
                                                            <div className="d-flex justify-content-between">
                                                                    <label className="h7"> <strong>Like New</strong></label>
                                                                    <Field className="mt-1" type="radio" name="condition" value='Like New' onClick={()=>scrollToSection(section1Ref)}/>
                                                            </div>
                                                                <hr></hr>
                                                                    <label className="">
                                                                    <span style={{fontSize:14}} className="extra-txt ng-binding" ng-show="answer.tooltip.length"> 
                                                                    <span style={{fontSize:15, fontWeight:500}}>All of the below is true </span>
                                                                            <ul>
                                                                                <li>Everything works fine.</li>
                                                                                <li>Immaculate cosmetic condition.</li>
                                                                                <li>Not a single scuffs and/or dents of any kind on anywhere.</li>                                                                
                        
                                                                            </ul>
                                                                            
                                                                        </span>
                                                                    </label>
                                                            </div>
                                                            <div className= {`${values.condition=== "Good"&&'grid-item1-bg'|| 'grid-item1'} `}>
                                                                    <div className="d-flex justify-content-between">
                                                                        <label className="h7"><strong>Good</strong> </label>
                                                                        <Field className="mt-1" type="radio" name="condition" value='Good' onClick={()=>scrollToSection(section1Ref)}/>
                                                                    </div>
                                                                    <hr></hr>
                                                                    <label className="">
                                                                    <span style={{fontSize:14}} className="extra-txt ng-binding" ng-show="answer.tooltip.length"> 
                                                                    <span style={{fontSize:15, fontWeight:500}}>All of the below is true </span>
                                                                            <ul>
                                                                                <li>Everything works fine.</li>
                                                                                <li>Minor wear barely noticable scuffs or/and chips.</li>
                                                                                <li>May have single scuff/scratch on the outer body but not on the display/screen.</li>
                                                                                <li>Must not have any dents or deep scratches.</li>
                                                                            </ul>
                                                                            
                                                                        </span>
                                                                    </label>
                                                                    </div>
                                                                    <div className= {`${values.condition=== "Fair"&&'grid-item1-bg'|| 'grid-item1'} `}>
                                                                                    <div className="d-flex justify-content-between">
                                                                                        <label className="h7"> <strong>Fair</strong></label>
                                                                                    <Field className="mt-1" type="radio" name="condition" value='Fair'  onClick={()=>scrollToSection(section1Ref)}/>
                                                                                    </div>
                                                                                    <hr></hr>
                                                                                    <label className="">
                                                                                    <span style={{fontSize:14}} className="extra-txt ng-binding" ng-show="answer.tooltip.length"> 
                                                                                        <span style={{fontSize:15, fontWeight:500}}>All of the below is true </span>
                                                                                        
                                                                                        <ul>
                                                                                            <li>Everything works fine.</li>
                                                                                            <li> Moderate to heavy wear with deep scuffs and/or dents on outer body and/or on Display.</li>
                                                                                        </ul>
                                                                                    </span>
                                                                                        
                                                                                    </label>
                                                                                </div>
                                                                    <div className= {`${values.condition=== "Defective"&&'grid-item1-bg'|| 'grid-item1'} `}>
                                                                                            <div className="d-flex justify-content-between">
                                                                                                <label className="h7"> <strong>Defective</strong></label>
                                                                                            <Field className="mt-1" type="radio" name="condition" value='Defective'  onClick={()=>scrollToSection(section1Ref)}/>
                                                                                            </div>
                                                                                            <hr></hr>
                                                                                            <label className="">
                                                                                            <span style={{fontSize:14}} className="extra-txt ng-binding" ng-show="answer.tooltip.length"> 
                                                                                                <span style={{fontSize:15, fontWeight:500}}>All of the below is true </span>
                                                                                                
                                                                                                <ul>
                                                                                                    <li>Comes on.</li>
                                                                                                    <li>Works fine except the funcationality issues like few keys sticky or not working, webcam don't work, etc. </li>
                                                                                                  
                                                                                                    <li>Need to repair to make it 100% functional.</li>
                                                                                                </ul>
                                                                                            </span>
                                                                                                
                                                                                            </label>
                                                                                        </div>
                                                                                                    
                                                                    <div className= {`${values.condition=== "Broken"&&'grid-item1-bg'|| 'grid-item1'} `}>
                                                                                                <div className="d-flex justify-content-between">
                                                                                                    <label className="h7"> <strong>Broken</strong></label>
                                                                                                <Field className="mt-1" type="radio" name="condition" value='Broken'  onClick={()=>scrollToSection(section1Ref)}/>
                                                                                                </div>
                                                                                                <hr></hr>
                                                                                                <label className="">
                                                                                                <span style={{fontSize:14}} className="extra-txt ng-binding" ng-show="answer.tooltip.length"> 
                                                                                                    <span style={{fontSize:15, fontWeight:500}}>Any one of the below is true </span>
                                                                                                    
                                                                                                    <ul>
                                                                                                        <li>Does not power on.</li>
                                                                                                        <li>Battery expanding, LCD or Display shattered/cracked.</li>
                                                                                                      
                                                                                                        <li>Falling apart from the back or display.</li>
                                                                                                    </ul>
                                                                                                </span>
                                                                                                    
                                                                                                </label>
                                                                                            </div>  
                                                        
                                                                </div>
                                                        </div> 
                                                        </>
                                                    }
                                       
                                               
                                    </>
                                }

                                {
                                    selectedDeviceSize && values.size && values.year && values.condition && <>
                                       
                                        <div className="d-flex align-items-center">
                                        <div className="border border-dark rounded mx-2  p-2" >
                                            <span style={{fontSize:14}}> 
                                                {values.condition} 
                                            </span>
                                        </div>
                                        <button className="border rounded-lg ml-2"
                                       
                                             onClick={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "condition",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "capacity",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "ram",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "powercord",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "batteryHealth",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "functional",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "processor",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "GCard",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "MagicKeyboard",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "MagicTrackpad",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "MagicMouse",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "ChargingAdapter",
                                                        value: '',
                                                    }
                                                })
                                                
                                                setIsBrokenFiled(false)
                                                setIsBrokenOrNo(false)
                                              
                                                setOffers()
                                            }} >  <span className="ml-3">
                                            <EditIcon/>
                                            </span>
                                            <span className="ml-1 cursor-pointer text-info "> Change condition</span>
                                            </button>
                                        </div>
                                        <hr />
                                        {/**values.year && !values.capacity && (values.condition === "Brand New" ? false : true) && !isProcessor &&selectedDeviceSize.sizeLabel!="MacBook Pro 13\"(2021 - Present)"&&
                                            <div className="ml-2">
                                                <h4>Select 1model storage capacity</h4>
                                            </div>
                                         */}
                                        {/**selectedDeviceSize.sizeLabel==="MacBook Pro 13\"(2021 - Present)"&&!isProcessor&&!values.capacity&&
                                            <div className="ml-2">
                                                <h4>Select storage capacity</h4>
                                            </div>
                                        */}
                                        {values.year  && isProcessor && !values.processor &&
                                            <div className="ml-2">
                                                <span style={{fontSize:20, fontWeight:500}}>Select Processor of the model:</span>
                                            </div>
                                        }
                                    </>
                                }

                                {(selectedDeviceYear && values.size && values.year && values.condition  && (isProcessor && !values.processor)) &&
                                    <div role="group" aria-labelledby="my-radio-group">
                                        <div className="grid-container">
                                            {selectedDeviceYear.processor.map((x, i) => (
                                                <>
                                               
                                              {x.GCard==="null"&&
                                                <>
                                                
                                               </>
                                              }
                                              {x.GCard!=="null"&&
                                                <>
                                                 <label key={i} className="border border-dark  cursor-pointer rounded p-2">
                                                <Field className="d-none" type="radio" name="processor" onClick={() => deviceProcessor(x)} 
                                                value={x.GCard} />
                                                {x.GCard}
                                                
                                                </label>
                                                 </>
                                               
                                              }
                                                
                                              </>
                                                
                                            ))}
                                        </div>
                                    </div>
                                }


                                {selectedDeviceYear && values.size && values.year && values.condition &&  isProcessor && values.processor && <>
                                    <div className="d-flex align-items-center">
                                        <div className="border border-dark rounded mx-2  p-2" >
                                            <span style={{fontSize:14}}> 
                                                {values.processor}
                                            </span>
                                        </div>
                                        <button className="border rounded-lg ml-2"
                                       
                                         onClick={(e) => {
                                            handleChange({
                                                target: {
                                                    name: "processor",
                                                    value: '',
                                                }
                                            })
                                            handleChange({
                                                target: {
                                                    name: "GCard",
                                                    value: '',
                                                }
                                            })
                                            handleChange({
                                                target: {
                                                    name: "capacity",
                                                    value: '',
                                                }
                                            })
                                            handleChange({
                                                target: {
                                                    name: "ram",
                                                    value: '',
                                                }
                                            })
                                            handleChange({
                                                target: {
                                                    name: "functional",
                                                    value: '',
                                                }
                                            })
                                            handleChange({
                                                target: {
                                                    name: "batteryHealth",
                                                    value: '',
                                                }
                                            })
                                            handleChange({
                                                target: {
                                                    name: "MagicKeyboard",
                                                    value: '',
                                                }
                                            })
                                            handleChange({
                                                target: {
                                                    name: "MagicTrackpad",
                                                    value: '',
                                                }
                                            })
                                            handleChange({
                                                target: {
                                                    name: "MagicMouse",
                                                    value: '',
                                                }
                                            })
                                            handleChange({
                                                target: {
                                                    name: "ChargingAdapter",
                                                    value: '',
                                                }
                                            })
                                            handleChange({
                                                    target: {
                                                        name: "powercord",
                                                        value: '',
                                                    }
                                                })
                                            setOffers()
                                            setSelectedDeviceProcessor()
                                           
                                            setIsBrokenOrNo(false)
            
                                        }} > <span className=""> <EditIcon/> </span>
                                         <span className="ml-1 cursor-pointer text-info" > Change processor</span>
                                        </button>
                                    </div>
                                    <hr />
                                    {values.year && !values.capacity  && 
                                       <div className="ml-2">
                                           <span style={{fontSize:20, fontWeight:500}}>Select storage capacity of the macbook:</span>
                                        </div>
                                    }
                                   
                                    
                                </>
                                }

                              { values.year && !values.capacity  && !isProcessor && values.condition&&
                                       <div className="ml-2">
                                            <span style={{fontSize:20, fontWeight:500}}>Select storage capacity of the macbook:</span>
                                        </div>
                                    }

                               

                                {selectedDeviceYear && values.size && values.year && !values.capacity && values.condition  && (isProcessor ? (values.processor ? true : false) : true) &&
                                    <div role="group" aria-labelledby="my-radio-group">
                                        <div className="grid-container">
                                        {selectedDeviceYear.processor.length>0 && selectedDeviceYear.processor.map((x, i) => (
                                                <>
                                             
                                               <>
                                                {
                                               x.GCard===values.processor&&
                                                        <>
                                                        {x.gb.map((x,y)=>(
                                                            <>
                                                            <label key={i} className="border border-dark text-center cursor-pointer rounded w-75 p-2">
                                                            <Field className="d-none" type="radio" name="capacity" value={x} />
                                                            {x}
                                                            </label>
                                                            </>
                                                        ))}
                                                        </>
                                                        
                                                        
                                                        
                                                    }
                                                    {
                                               x.GCard==="null"&&
                                                        <>
                                                        
                                                        {x.gb.length>0 && x.gb.map((x,y)=>(
                                                            <>
                                                            
                                                            <label key={i} className="border border-dark text-center cursor-pointer rounded w-75 p-2">
                                                            <Field className="d-none" type="radio" name="capacity" value={x} />
                                                            {x}
                                                            </label>
                                                            </>
                                                        ))}
                                                        </>
                                                        
                                                        
                                                        
                                                    }
                                                    
                                               </>
                                                    

                                               
                                         

                                                </>
                                            ))}
                                        </div>
                                    </div>
                                }

                                {
                                    selectedDeviceYear && values.size && values.year && values.capacity && values.condition && !isBrokenFiled && (isProcessor ? (values.processor ? true : false) : true) && (isGCard ? (values.GCard ? true : false) : true) && <>
                                        <div className="d-flex align-items-center">
                                            <div className="border border-dark rounded mx-2  p-2" >
                                            <span style={{fontSize:14}}> 
                                                {values.capacity}
                                            </span>
                                            </div>
                                            <button className="border rounded-lg ml-2"
                                          
                                             onClick={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "capacity",
                                                        value: '',
                                                    }
                                                }) 
                                                handleChange({
                                                    target: {
                                                        name: "functional",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "MagicKeyboard",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "MagicTrackpad",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "MagicMouse",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "ChargingAdapter",
                                                        value: '',
                                                    }
                                                }) 
                                                handleChange({
                                                    target: {
                                                        name: "ram",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "powercord",
                                                        value: '',
                                                    }
                                                })
                                                setOffers()
                                                setIsBrokenOrNo(false)
                                               

                                            }} >  <span className=""> <EditIcon/> </span>
                                             <span className="ml-1 cursor-pointer text-info" >  Change storage capacity</span>
                                            </button>
                                        </div>
                                        <hr />
                                        {values.capacity && !values.ram &&
                                            <div className="ml-2">
                                               <span style={{fontSize:20, fontWeight:500}}>Select RAM memory of the macbook:</span>
                                            </div>
                                        }
                                    </>
                                }

                                {selectedDeviceYear && values.size && values.year && values.capacity && !values.ram && values.condition  && (isProcessor ? (values.processor ? true : false) : true) &&
                                    <div role="group" aria-labelledby="my-radio-group">
                                        <div className="grid-container">
                                        {selectedDeviceYear.processor.length>0 && selectedDeviceYear.processor.map((x, i) => (
                                                <>
                                             
                                               <>
                                                {
                                               x.GCard===values.processor&&
                                                        <>
                                                        {x.ram.map((x,y)=>(
                                                            <>
                                                            <label key={i} className="border border-dark text-center cursor-pointer rounded w-75 p-2">
                                                            <Field className=" d-none" type="radio" name="ram" value={x} />
                                                            {x}
                                                            </label>
                                                            </>
                                                        ))}
                                                        </>
                                                        
                                                        
                                                        
                                                    }
                                                    {
                                               x.GCard==="null"&&
                                                        <>
                                                        
                                                        {x.ram.length>0 && x.ram.map((x,y)=>(
                                                            <>
                                                            
                                                            <label key={i} className="border border-dark text-center cursor-pointer rounded w-75 p-2">
                                                            <Field className=" d-none" type="radio" name="ram" value={x} />
                                                            {x}
                                                            </label>
                                                            </>
                                                        ))}
                                                        </>
                                                        
                                                        
                                                        
                                                    }
                                                    
                                               </>
                                                    

                                               
                                         

                                                </>
                                            ))}
                                        </div>
                                    </div>
                                }


                                {
                                    selectedDeviceYear && values.size && values.year && values.capacity && values.ram && values.condition && (isProcessor ? (values.processor ? true : false) : true) && (isGCard ? (values.GCard ? true : false) : true) && <>
                                        <div className="d-flex align-items-center">
                                        <div className="border border-dark rounded mx-2  p-2" >
                                        <span style={{fontSize:14}}> 
                                            {values.ram}
                                        </span>
                                            </div>
                                        <button className="border rounded-lg ml-2"
                                         onClick={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "ram",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "powercord",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "functional",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "batteryHealth",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "MagicKeyboard",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "MagicTrackpad",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "MagicMouse",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "ChargingAdapter",
                                                        value: '',
                                                    }
                                                })
                                                setOffers()
                                                setIsBrokenOrNo(false)
                                               
                                              
                                            }} > <span className=""> <EditIcon/> </span>
                                         <span className="ml-1 cursor-pointer text-info ">  Change RAM memory</span>
                                            </button>
                                        </div>
                                        <hr />
                                        {values.ram && !values.functional && (values.condition === "Brand New" ? false : true)&&
                                            <div className="ml-2"> 
                                                 <span style={{fontSize:20, fontWeight:500}}>Is your macbook fully functional?</span>
                                            </div>
                                        }
                                    </>
                                }

                                {

                                    selectedDeviceYear && values.size && values.year && values.capacity && values.ram && values.condition && !values.functional && (values.condition === "Brand New" ? false : true) &&
                                <>
                                    <div className="grid-container" role="group" aria-labelledby="my-radio-group">
                                            <div className= {`${values.functional=== "Yes"&&'grid-item1-bg'|| 'grid-item1'} `}>
                                                    <div className="d-flex justify-content-between">
                                                                <label className="h7"><storng>Yes</storng> </label>
                                                                        <Field className="mt-1" type="radio" name="functional" value='Yes'  onClick={()=>scrollToSection(section1Ref)}/>
                                                    </div>
                                                        <hr></hr>
                                                        <label className="">
                                                        <span style={{fontSize:14}} className="extra-txt ng-binding" ng-show="answer.tooltip.length"> 
                                                        <span style={{fontSize:15, fontWeight:500}}>All of the below is true </span>
                                                        <ul>
                                                            <li>Macbook doen't have any functional issue</li>
                                                            <li>Macbook comes on and successfully load the OS</li>
            
                                                        </ul>
                                                                
                                                            </span>
                                                        </label>
                                                </div>
                                                <div className= {`${values.functional=== "No"&&'grid-item1-bg'|| 'grid-item1'} `}>
                                                    <div className="d-flex justify-content-between">
                                                    <label className="h7"><storng>No</storng> </label>
                                                        <Field className="mt-1" type="radio" onClick={() => {
                                                            setIsBrokenOrNo(true)
                                                            handleChange({
                                                                target: {
                                                                    name: "powercord",
                                                                    value: '',
                                                                }
                                                            })
                                                            handleChange({
                                                                target: {
                                                                    name: "functional",
                                                                    value: '',
                                                                }
                                                            })
                                                            handleChange({
                                                                target: {
                                                                    name: "batteryHealth",
                                                                    value: '',
                                                                }
                                                            })
                                                            handleChange({
                                                                target: {
                                                                    name: "MagicKeyboard",
                                                                    value: '',
                                                                }
                                                            })
                                                            handleChange({
                                                                target: {
                                                                    name: "MagicTrackpad",
                                                                    value: '',
                                                                }
                                                            })
                                                            handleChange({
                                                                target: {
                                                                    name: "MagicMouse",
                                                                    value: '',
                                                                }
                                                            })
                                                            handleChange({
                                                                target: {
                                                                    name: "ChargingAdapter",
                                                                    value: '',
                                                                }
                                                            })
                                                           
                                                        }} name="functional" value='No' />
                                                         </div>
                                                         <hr></hr>
                                                        <label className="mt-2">
                                                        <span style={{fontSize:14}} className="extra-txt ng-binding" ng-show="answer.tooltip.length"> 
                                                        <span style={{fontSize:15, fontWeight:500}}>All of the below is true </span>
                                                    <ul>
                                                        <li>Macbook doesn't comes on or power on</li>
                                                        <li>Macbook doesn't load OS successfully</li>

                                                    </ul>
                                                  
                                                </span>
                                            </label>
                                            </div>
                                            
                                            </div>
                                        </>
                                    }
                                                    
                                        
                                       

                                {
                                    selectedDeviceYear && values.size && values.year && values.capacity && values.ram && values.condition && values.functional && (isProcessor ? (values.processor ? true : false) : true) &&  <>
                                        <div className="d-flex align-items-center">
                                        <div className="border border-dark rounded mx-2  p-2" >
                                        <span style={{fontSize:14}}> {values.functional}
                                        </span>
                                                 </div>
                                                 <button className="border rounded-lg ml-2"
                                                
                                         onClick={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "functional",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "batteryHealth",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "powercord",
                                                        value: '',
                                                    }
                                                })
                                                setOffers()
                                                setIsBrokenOrNo(false)
                                                setIsBrandNew(false)
                                                setOfferShow(true)
                                            }} > <span className="ml-3">
                                            <EditIcon/></span>
                                    <span className="ml-1 cursor-pointer text-info" >  Change laptop functionality</span>
                                            </button>
                                        </div>
                                        <hr />
                                        {values.ram && !values.batteryHealth && !isBrokenOrNo  &&(values.condition === "Brand New" ? false : true)&&
                                            <div className="ml-2">
                                                 <span style={{fontSize:20, fontWeight:500}}>Select cacbook's battery health</span>
                                            </div>
                                        }
                                       
                                    </>
                                }

                                {selectedDeviceYear && values.size && values.year && values.capacity && values.ram && values.condition && !values.batteryHealth  && values.functional && !isBrokenOrNo && (isProcessor ? (values.processor ? true : false) : true) &&
                                <>
                                 <div className="grid-container"  role="group" aria-labelledby="my-radio-group">
                                                <div className= {`${values.functional=== "Good"&&'grid-item1-bg'|| 'grid-item1'} `}>
                                                    <div className="d-flex justify-content-between">
                                                            <label className="h7"><storng>Good</storng> </label>
                                                            <Field className="mt-1" type="radio" name="batteryHealth" value="Good"  />
                                                    </div>
                                                        <hr></hr>
                                                        <label className="">
                                                        <span style={{fontSize:14}} className="extra-txt ng-binding" ng-show="answer.tooltip.length"> 
                                                        <span style={{fontSize:15, fontWeight:500}}>Any of the below is true </span>
                                                        <ul>
                                                            <li>Battery status/health is Normal</li>
                                                            <li>Battery capacity is more than 80%</li>
                                                        
                                                        </ul>
                                                                
                                                            </span>
                                                        </label>
                                                </div>
                                                <div className= {`${values.functional=== "Poor"&&'grid-item1-bg'|| 'grid-item1'} `}>
                                                    <div className="d-flex justify-content-between">
                                                            <label className="h7"><storng>Poor</storng> </label>
                                                            <Field className="mt-1" type="radio" name="batteryHealth" value="Poor"  />
                                                    </div>
                                                        <hr></hr>
                                                        <label className="">
                                                        <span style={{fontSize:14}} className="extra-txt ng-binding" ng-show="answer.tooltip.length"> 
                                                        <span style={{fontSize:15, fontWeight:500}}>Any of the below is true </span>
                                                        <ul>
                                                            <li>Battery Servie Recommended/Replace Now</li>
                                                            <li>or Replace Battery Soon warning</li> 
                                                            <li>or/and battery capacity is less than 80%</li>
                                                        </ul>
                                                                
                                                            </span>
                                                        </label>
                                                </div>

                                    </div>
                                    </>
                                  
                                }

                                {
                                    selectedDeviceYear && values.size && values.year && values.capacity && values.ram && values.condition && values.functional && values.batteryHealth  && (isProcessor ? (values.processor ? true : false) : true) && (values.condition === "Brand New" ? false : true)&&<>
                                        <div className="d-flex align-items-center">
                                        <div className="border border-dark rounded mx-2  p-2" >
                                        <span style={{fontSize:14}}>{values.batteryHealth}
                                            </span> 
                                                </div>
                                              
                                                <button className="border rounded-lg ml-2"
                                                
                                         onClick={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "batteryHealth",
                                                        value: '',
                                                    }
                                                })
                                                handleChange({
                                                    target: {
                                                        name: "powercord",
                                                        value: '',
                                                    }
                                                })
                                                setOffers()
                                                setOfferShow(false)
                                                setIsBrokenOrNo(false)
                                            }} ><span className="ml-3">
                                            <EditIcon/></span> 
                                           
                                     <span className="ml-1 cursor-pointer text-info " >  Change Battery Health</span>
                                            </button>
                                        </div>
                                        <hr />
                                        {values.batteryHealth && !values.powercord  &&(values.condition === "Brand New" ? false : true)&&
                                            <div className="ml-2">
                                                <span style={{fontSize:17, fontWeight:500}}>Will you be including the charging cable and adaptor?</span>
                                            </div>
                                        }
                                    </>
                                }

                                {

                                    selectedDeviceYear && values.size && values.year && values.capacity && values.ram && values.condition && values.batteryHealth&&
                                    !values.powercord && values.functional && !isBrokenOrNo && (isProcessor ? (values.processor ? true : false) : true) && 
                                    (values.condition === "Brand New" ? false : true)&&
                                    <>
                                        <div className="grid-container" role="group" aria-labelledby="my-radio-group">
                                            
                                                
                                                <label style={{fontSize:22, fontWeight:500}}className="mt-1">
                                                <div className="border border-dark w-70 rounded-lg  text-center" >
                                                    Yes
                                                    <Field className="d-none" type="radio" name="powercord" value='Yes' />
                                                </div>
                                                </label>
                                                
                                            
                                          
                                           
                                                
                                                <label style={{fontSize:22, fontWeight:500}}className="mt-1">
                                                <div className="border border-dark w-70 rounded-lg  text-center" >
                                                    No
                                                    <Field className="d-none" type="radio" name="powercord" value='No' />
                                                </div>
                                                </label>
                                                
                                            </div>
                                       
                                    </>
                                }

                                {
                                    selectedDeviceYear && values.size && values.year && values.capacity && values.ram && values.condition  && values.powercord && values.functional && (isProcessor ? (values.processor ? true : false) : true) && 
                                     (values.condition === "Brand New" ? false : true)&& <>
                                        <div className="d-flex align-items-center">
                                        <div className="border border-dark rounded mx-2  p-2" >
                                        <span style={{fontSize:14}}>{values.powercord}
                                            </span> 
                                                 </div>
                                                 <button className="border rounded-lg ml-2"
                                                
                                            onClick={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "powercord",
                                                        value: '',
                                                    }
                                                })
                                                setOffers()
                                                setIsBrokenOrNo(false)
                                                setIsBrandNew(false)
                                                setOfferShow(true)
                                            }} ><span className="ml-3">
                                            <EditIcon/></span> 
                                           
                                        <span className="ml-1 cursor-pointer text-info" >  Change charger includes</span>
                                            </button>
                                        </div>
                                    </>
                                }

                               

                                {
                                    ((isEmpty(offers) && selectedDeviceYear && values.size && values.year && values.capacity && values.ram && values.condition  && values.batteryHealth&& values.powercord&&values.functional&& (isProcessor ? (values.processor ? true : false) : true) &&  !isBrokenFiled&& !isBrandNew )) &&
                                    <div className="col-md-12">
                                        <div className="d-flex justify-content-center">
                                            <div className="col-md-6 mt-4 text-center">
                                                <Button variant="outline-secondary" className="w-100" type="submit">Show My Offer</Button>
                                            </div>
                                        </div>
                                    </div>
                                }

                                {
                                     (values.condition === "Brand New" ? true : false)&& (isProcessor ? (values.processor ? true : false) : true) &&values.capacity&&values.ram&&isEmpty(offers)&&
                                    <div className="col-md-12">
                                        <div className="d-flex justify-content-center " ref={section1Ref}>
                                            <div className="col-md-6 mt-4 text-center">
                                                <Button variant="outline-secondary" className="w-100" type="submit"onClick={() => {
                                                   
                                                    setIsBrokenFiled(false)
                                                }} >Show My Offer</Button>
                                            </div>
                                        </div>
                                    </div>
                                }

                                {isLoader && isEmpty(offers) &&
                                    <div className="text-center col-md-12">
                                        <LoaderSpinner></LoaderSpinner>
                                    </div>
                                }

                                {!isEmpty(offers) && !isBrokenOrNo &&
                                    <div className="mt-4 col-md-12 text-center">
                                        <div className="d-flex justify-content-center">
                                            <div className="col-md-3">
                                                <h1 className="border rounded p-4 m-0">
                                                    $ {offers[0].offer}
                                                </h1>
                                                <div className="border-right p-1 border-bottom border-left">
                                                    <h5 className="mt-1">Your Offer </h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-center">
                                            <div className="mt-4 col-md-6">
                                                <Button variant="outline-success" className="w-100" onClick={() => addCart({...offers[0],condition:values.condition})} type="submit"><span className="h4">Sell Now</span></Button>
                                            </div>
                                        </div>
                                        <div className="mt-3 mx-2"style={{fontSize: "14px"}}>
                                        *Offered value of the device is subject to device review 
                                        We may requote you with higher offer value if we find the cosmetic condition of the device better than what you thought of and vice versa.
                                       We process the payment immediately after receiving your device we offer free express shipping. 
                                        We don’t pay for the devices that have been reported lost or stolen
                                    </div>
                                    </div>
                                }

                                {isBrokenOrNo &&
                                    <div className="border rounded-lg mt-4 col-md-12 text-center">
                                        <div className="mt-3 bg-custom-danger">
                                        <p className="mx-3,my-3">Currently we’re not able to offer any value for the selected device in described condition but 
                                        we can safely recycle it in a way which won’t harm environment in any way and leave zero carbon footprint.
                                        you can either proceed to recycle now or simply keep the device with you,
                                        and checkout value of other devices if you're looking to sell them as well.
                                       </p>

                                        </div>
                                        <div className="d-flex justify-content-center">
                                        {values.functional==="No"&&
                                            <div className="mt-4 col-md-6">
                                                <Button variant="outline-primary" className="w-100"
                                                    onClick={() => addCart({
                                                      
                                                        model: values.year,
                                                        storage: values.capacity,
                                                        offer:0,
                                                        condition: values.condition,
                                                       
                                                        processor: values.processor,
                                                       
                                                        ram:values.ram,
                                                        
                                                        screen_size: values.size.split('///')[0],
                                                       
                                                      
                                                    })}
                                                >Recycle now</Button>
                                            </div>}
                                            {values.functional==="Yes"&&
                                            <div className="mt-4 col-md-6">
                                                <Button variant="outline-primary" className="w-100"
                                                    onClick={() => addCart({...offers[0],condition:values.condition})}
                                                >Recycle now</Button>
                                            </div>}
                                            
                                        </div>
                                        <div className="d-flex justify-content-center">
                                        <div className="mt-4 col-md-6">
                                            <Button variant="outline-primary" className="w-100" onClick={() => {{window.location.href="/sellADevice"}}}
                                            >Check values of other devices</Button>

                                        </div>
                                    </div>


                                    </div>
                                }

                            </div>
                        }
                    </Form>
                )}
            </Formik>
        </div >
        
    )
}

export default MacBook
